import SaleChartUI from "features/Report/SaleChartUI";
import React from "react";

const SaleReport = () => {
  return <SaleChartUI />;
};

export default SaleReport;
